import { ReactNode } from "react";

interface FlexContainerProps {
  children: ReactNode;
  className?: string;
}

export default function FlexContainer({ children, className = "" }: FlexContainerProps) {
  return <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>{children}</div>;
}
